import React from 'react'
import { Building2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setContextCompany } from '../../../redux/context/company/actions'
import { contextCompanySelector } from '../../../redux/context/company/selectors'
import { loadingSelector } from '../../../redux/loading/selectors'
import { currentUserSortedCompaniesSelector } from '../../../redux/session/currentUser/selectors'
import { AppDispatch } from '../../../redux/store'
import CurrentUserCompaniesSelect from '../../company/components/CurrentUserCompaniesSelect'
import LucideIcon from '../../../shared/components/LucideIcon'

type ContextCompanySelectProps = {
  width?: number
  /** Width of the dropdown, so long company names fit even when the select itself is narrow. */
  popupWidth?: number
}

const ContextCompanySelect = ({ width = 240, popupWidth = 360 }: ContextCompanySelectProps) => {
  const { t } = useTranslation()
  const dispatch: AppDispatch = useDispatch()

  const selectedCompany = useSelector(contextCompanySelector)
  const companies = useSelector(currentUserSortedCompaniesSelector)
  const { contextCompany: contextCompanyLoading } = useSelector(loadingSelector)

  return (
    <CurrentUserCompaniesSelect
      prefix={<LucideIcon icon={Building2} />}
      onChange={(value: string) => {
        const company = companies.find(c => c.id === value)
        if (company) {
          dispatch(setContextCompany(company))
        }
      }}
      loading={contextCompanyLoading}
      className="context-company-select"
      style={{ width }}
      // Never narrower than the select itself
      popupMatchSelectWidth={Math.max(width, popupWidth)}
      placeholder={t('global:set-context-company')}
      value={selectedCompany ? selectedCompany.id : undefined}
    />
  )
}

export default ContextCompanySelect
